<template>
    <select-input
        :items="availableFonts"
        label-key-name="name"
        value-key-name="name"
    >
        <template #active="{ bindings }">
            <span v-if="!bindings.value || !bindings.value.name">
                Kies een font
            </span>
            <text-decorator v-else :font="bindings.value.name">
                {{ bindings.value.name.replace(/\+/g, ' ') }}
            </text-decorator>
        </template>
        <template #item="{ bindings }">
            <text-decorator :font="bindings.item.name">
                {{ bindings.item.name.replace(/\+/g, ' ') }}
            </text-decorator>
        </template>
    </select-input>
</template>

<script setup lang="ts">
    import { useConfiguration, SelectInput } from '@keyvue/one-ui';
    import { computed } from 'vue';

    const { fontConfiguration } = useConfiguration();

    const availableFonts = computed(() => {
        return [
            ...fontConfiguration.fonts ?? [],
            {
                name: 'Global font',
                sizes: [300, 400, 500, 600, 700],
                fallback: 'serif',
            },
            {
                name: 'Arial',
                sizes: [300, 400, 500, 600, 700],
                fallback: 'serif',
            },
        ].sort((a, b) => a.name.localeCompare(b.name));
    });
</script>
